// Layout
const dashboardLayout = () => import('@/layouts/HospitalLayout/DashboardLayout/dashboardLayout.vue')

const financialOperations = () => import('./views/index')

// start Routes
export default [
  {
    path: '/hospital/financialOperations',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'hospitalFinancialOperations',
      meta: {
        name: 'hospitalFinancialOperations',
        parentName: 'marketplace',
        userType: '',
        permission: '',
        role: 'veterinary.clinic_owner'
      },
      component: financialOperations
    }]
  }
]
